// extracted by mini-css-extract-plugin
export var iframeContainer = "VimeoVideo-module--iframe-container--01653";
export var playButton = "VimeoVideo-module--play-button--b0cde";
export var thumbnailContainer = "VimeoVideo-module--thumbnail-container--cb4af";
export var videoThumbnail = "VimeoVideo-module--video-thumbnail--df252";